var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('button',{staticClass:"k-button k-grid-remove-command",class:[_vm.readonly || _vm.disabled ? 'disabled' : '', _vm.className],on:{"click":_vm.removeHandler}})])}
var staticRenderFns = []

export { render, staticRenderFns }